module.exports = __webpack_public_path__ + "files/6997ff5fa0ae88036bb7d12ed4ad4e92.svg";